import React from "react";
import { Axis, Chart, Coord, Geom, Label, Tooltip } from "bizcharts";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import {
  Card,
  Tooltip as MuiTooltip,
  CardHeader,
  Typography,
  CardContent,
} from "@material-ui/core";
import { tooltips } from "../../constants/tooltips";
import { colours } from "../../utilities/styles";

const DashboardJourneyLevelChart = (props: {
  journey_sessions: Array<{
    count: number;
    no_of_session: number;
  }>;
}) => {
  const sum = props.journey_sessions.reduce((pre, cur) => pre + cur.count, 0);
  const data = props.journey_sessions
    .map((e) => ({
      count: e.count,
      members: e.count,
      percentage: `${Math.round((e.count / sum) * 100)}%`,
      level: `${e.no_of_session} ${e.no_of_session > 0 ? "+ activities" : "activity"}`,
    }))
    .reverse();

  return (
    <Card style={{ height: "450px" }}>
      <CardHeader
        title={
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              padding: "8px 0 30px 20px",
            }}
          >
            <Typography variant="h6">Where is everybody in their journey?</Typography>
            <MuiTooltip
              title={<Typography>{tooltips.journeyChart}</Typography>}
              aria-label="journeyChart"
            >
              <HelpOutlineIcon />
            </MuiTooltip>
          </div>
        }
        style={{ padding: "8px 8px 0 0" }}
      />
      <CardContent>
        <Chart
          height={350}
          width={(window.innerWidth - 250 - 16 * 2 - 24 * 2) * 0.5}
          data={data}
          padding={["auto", "100"]}
          style={{ padding: "0 10px 30px 10px" }}
        >
          <Coord transpose />
          <Axis name="count" visible={false} />
          <Axis name="members" title visible={false} />
          <Axis name="percentage" visible={false} />
          <b>
            <Axis name="level" visible={true} />
          </b>
          <Tooltip />
          <Geom
            type="interval"
            position="level*count*"
            shape="smooth"
            tooltip={[
              "level*percentage",
              (level, percentage) => {
                return {
                  name: percentage,
                  value: "",
                };
              },
            ]}
          >
            <Geom
              type="interval"
              position="level*count*"
              tooltip={[
                "level*members",
                (level, members) => {
                  return {
                    name: members + " members",
                    value: "",
                    color: "#FF7733",
                  };
                },
              ]}
              color={["count", colours.yomento_purple]}
              shape="smooth"
            ></Geom>
            <Label
              content={[
                "level*count*",
                (name, value) => (sum ? `${Math.round((value / sum) * 100)}%` : ""),
              ]}
            />
          </Geom>
        </Chart>
      </CardContent>
    </Card>
  );
};

export default DashboardJourneyLevelChart;
